<!-- <h1>Summery Order</h1>

<mat-card>
  <mat-card-content>Flight Details:</mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>Hotel Details:</mat-card-content>
</mat-card>


<mat-accordion>
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
    </mat-expansion-panel-header>
  </mat-expansion-panel>
  <mat-expansion-panel (opened)="panelOpenState = true"
                       (closed)="panelOpenState = false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Flight Details:
      </mat-panel-title> -->
      <!-- <mat-panel-description>
        Flight Details:
      </mat-panel-description> -->
    <!-- </mat-expansion-panel-header>
    <p>I'm visible because I am open</p>
  </mat-expansion-panel>
</mat-accordion> -->

<mat-card class="payment-page">
  <h2>Payment Page</h2>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3>Flight Details</h3>
      </mat-panel-title>
      <mat-panel-description>
        <mat-icon>{{ showFlightDetails ? 'remove' : 'add' }}</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div class="details">
        <h4>Passengers Details:</h4>
        <!-- Display passengers details here -->
        <h4>Time of Departure:</h4>
        <!-- Display time of departure here -->
        <h4>Time of Arrival:</h4>
        <!-- Display time of arrival here -->
        <h4>Flight Number:</h4>
        <!-- Display flight number here -->
        <h4>Dates:</h4>
        <!-- Display flight dates here -->
      </div>
    </ng-template>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3>Hotel Details</h3>
      </mat-panel-title>
      <mat-panel-description>
        <mat-icon>{{ showHotelDetails ? 'remove' : 'add' }}</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div class="details">
        <h4>Name and Address of the Hotel:</h4>
        <!-- Display hotel name and address here -->
        <h4>Number of Nights:</h4>
        <!-- Display number of nights here -->
        <h4>Number of Rooms:</h4>
        <!-- Display number of rooms here -->
        <h4>Date:</h4>
        <!-- Display hotel date here -->
      </div>
    </ng-template>
  </mat-expansion-panel>
</mat-card>
